import { ColorPicker } from "primereact/colorpicker";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  setShopHomeCms,
  saveThemeJsonData,
  fetchCroppedImage,
} from "../../../../redux/Actions";
import ImageCropper from "../../../imageCropper/imageCropper";

function SectionNineBannerThemeFour() {
  const dispatch = useDispatch<any>();
  const [editData, setEditData] = useState<any>({
    home: {
      section_9: {
        title: "",
        paragraph: "",
        banner: [],
        card_section: {
          collection: [],
        },
      },
    },
  });
  const jsonData: any = useSelector<any>((state) => state.shopHomeJsonList);
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState("");
  const [cropImageWidth, setCropImageWidth] = useState("");
  const [selectedCropImage, setSelectedCropImage] = useState("");
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [bannerImageChange, setBannerImageChange] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>("" || undefined);
  const images: Array<string> = [
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg4.jpg",
    "assets/home/trustimg4.jpg",
  ];
 

  const saveJsonDataToFile = () => {
    dispatch(setShopHomeCms(editData));
    dispatch(saveThemeJsonData(editData));
  };


  const updateImageSectionBanner = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    // setBannerImageChange(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await dispatch(fetchCroppedImage(image));

    if (imageLink != false) {
      handleBannerImageChange(imageLink);
    }
  };

  useEffect(() => {
    setEditData(jsonData);
  }, [jsonData]);
  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);



  const handleChange = (e: any, index?: any) => {
    const { value, name } = e.target;
    if (index !== undefined) {
      setEditData((prevJsonData: any) => {
        const updatedCollection = prevJsonData.theme_4.home.section_9.card_section.collection.map(
          (card: any, cardIndex: number) => {
            if (cardIndex === index) {
              return { ...card, [name]: value };
            }
            return card;
          }
        );
  
        return {
          ...prevJsonData,
          theme_4: {
              ...prevJsonData.theme_4,
          home: {
            ...prevJsonData.theme_4.home,
            section_9: {
              ...prevJsonData.theme_4.home.section_9,
              card_section: {
                ...prevJsonData.theme_4.home.section_9.card_section,
                collection: updatedCollection,
              },
            },
          },
      },
        };
      });
    } else {
      setEditData((prevJsonData: any) => ({
        ...prevJsonData,
        theme_4: {
          ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_9: {
            ...prevJsonData.theme_4.home.section_9,
            [name]: value,
          },
        },
      },
      }));
    }
  };

  const addCollection = () => {
    const updatedCollection: any = [
      ...editData.theme_4.home.section_9.card_section.collection,
    ];

    const newCard = {
      collection_title: "",
      collection_paragraph: "",
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
      home: {
        ...prevJsonData.theme_4.home,
        section_9: {
          ...prevJsonData.theme_4.home.section_9,
          card_section: {
            collection: updatedCollection,
          },
        },
      },
    },
    }));
  };

  const removeCollection = (index: any) => {
    const updatedCollection: any = [
      ...editData.theme_4.home.section_9.card_section.collection,
    ];
    updatedCollection.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
      home: {
        ...prevJsonData.theme_4.home,
        section_9: {
          ...prevJsonData.theme_4.home.section_9,
          card_section: {
            collection: updatedCollection,
          },
        },
      },
    },
    }));
  };


  const handleBannerImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        ...prevJsonData.theme_4,
        home: {
          ...prevJsonData.theme_4.home,
          section_9: {
            ...prevJsonData.theme_4.home.section_9,
            card_image: image,
          },
        },
      },
    }));
  };

  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section 9 Theme 4 Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editData?.theme_4?.home?.section_9?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      className="form-control"
                      name="description"
                      value={editData?.theme_4?.home?.section_9?.description}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="form-label">
                          First card background
                        </label>
                        <div className="img-bg active">
                          <img
                            src={
                              editData?.theme_4?.home?.section_9
                                ?.card_image
                            }
                            alt="Hero Image"
                          />
                        </div>
                        <div className="img-options">
                          <div className="row">
                            <div className="col-md-12">
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {images.map((images: string) => {
                                  return (
                                    <>
                                      <SwiperSlide>
                                        <div
                                          className="img-option"
                                          onClick={() =>
                                            handleBannerImageChange(images)
                                          }
                                        >
                                          <img
                                            src={images}
                                            alt="Hero Image"
                                            className="img-fluid"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    </>
                                  );
                                })}
                              </Swiper>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Upload Image</label>
                    <input
                      type="file"
                      accept="image/png, image/jpeg image/jpg"
                      className="form-control"
                      name="image"
                      onChange={updateImageSectionBanner}
                    />
                  </div>
                  
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_4?.home?.section_9?.card_section?.collection.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? "active" : ""
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Q&A Section {index + 1}
                          </a>
                          <a className="tab-close" onClick={() => {removeCollection(index)}}>
                            <i
                              className="fas fa-times"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_4?.home?.section_9?.card_section?.collection.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? "show active" : ""
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">

                          <div className="img-options w-100">
                            <Swiper
                              spaceBetween={15}
                              navigation={true}
                              modules={[Navigation]}
                              breakpoints={{
                                640: {
                                  slidesPerView: 1,
                                },
                                768: {
                                  slidesPerView: 4,
                                },
                                1024: {
                                  slidesPerView: 6,
                                },
                              }}
                              className="homejson-slider"
                            >
                            </Swiper>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                        Question<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control" 
                          name="collection_title"
                          value={card.collection_title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Answer</label>
                        <input
                          type="text"
                          className="form-control"
                          name="collection_paragraph"
                          value={card.collection_paragraph}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={1200}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="mb-3">
              <div className="add-section">
                <div className="row">
                  <div
                    onClick={() => {
                      addCollection();
                    }}
                    className="col text-center"
                  >
                    Add Card<i className="fas fa-plus-square ms-2"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonDataToFile();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: "block" }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
}

export default SectionNineBannerThemeFour;
